"use strict";
/**
 * Google Contacts Sync - Request Types
 *
 * Request contracts for the Google Contacts sync feature.
 *
 * @example POST /api/google-contacts/sync
 */
Object.defineProperty(exports, "__esModule", { value: true });
